import React from 'react'
import { getContext, useValues } from 'kea'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'

import App from './app'

import router from './router'

export default function Layout (props) {
  const { store } = getContext()

  return (
    <Provider store={store}>
      <LayoutInner {...props} />
    </Provider>
  )
}

function LayoutInner ({
  railsContext: { headerProps, footerProps, contentClassName, plainLayout },
  bundles,
  Header,
  Footer
}) {
  const { scene } = useValues(router)

  const showHeader = !plainLayout && scene !== 'search' && scene !== 'inboxThread'
  const showFooter = !plainLayout
  const SceneBundle = bundles[scene]

  return (
    <App>
      {showHeader && (
        <div className='hide-on-booking'>
          <Header {...headerProps} />
        </div>
      )}
      <div id='content' className={contentClassName}>
        <SceneBundle />
      </div>
      {showFooter && (
        <div id='new-footer'>
          <Footer {...footerProps} />
        </div>
      )}
    </App>
  )
}

LayoutInner.propTypes = {
  railsContext: PropTypes.object,
  bundles: PropTypes.object,
  Header: PropTypes.elementType,
  Footer: PropTypes.elementType
}
